// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jszip/~/pako/index.js
 ** module id = 623
 ** module chunks = 0
 **/